import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { hideMobileMenu, showMobileMenu } from '../../store/actions/UI';

import './style.scss';

const Hamburger = () => {
  const dispatch = useDispatch();
  const mobileMenuVisible = useSelector((state) => state.getIn(['uiInternal', 'showMobileMenu']));
  const classes = classNames('Hamburger', 'icon', 'icon-variant-2', {
    'icon-menu': !mobileMenuVisible,
    'icon-close': mobileMenuVisible,
  });

  const onClick = () => {
    if (mobileMenuVisible) {
      dispatch(hideMobileMenu());
    } else {
      dispatch(showMobileMenu());
    }
  };

  return (
    <div className={classes} onClick={() => onClick()}>
      Hamburger
    </div>
  );
};

export default Hamburger;
